// import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const companyManageRouter = {
  path: '/companyManage',
  component: () => import('@/layout'),
  redirect: '/companyManage/appManage',
  name: 'companyManage',
  meta: {
    title: '企业管理',
    icon: 'openPlat'
  },
  children: [
    {
      path: 'appManage',
      component: () => import('@/views/companyManage/page/applaction.vue'),
      name: 'appManage',
      meta: { title: '应用管理' }
    }
  ]
}
export default companyManageRouter
